import { showToast } from '@quickmd-llc/design-system'
import { readApiErrorCode } from './readApiErrorCode'

const DEFAULT_MESSAGE = 'Something went wrong. Please try again.'

// Backend error type (ErrorCode) -> user-facing copy. Extend as endpoints add types.
const ERROR_COPY: Record<string, string> = {
  FileTagNotValid: 'That file tag is not valid.',
  PeriodNotValid: 'The completed or expiration date is not valid.',
  FileNotFound: 'That file could not be found. Please try again.',
  PatientNotFound: 'Patient record not found. Please refresh and try again.',
  InternalServerError: 'Server error. Please try again or contact support.',
}

export function showApiErrorToast(error: unknown, options?: { fallback?: string }): void {
  const code = readApiErrorCode(error)
  const message = (code && ERROR_COPY[code]) || options?.fallback || DEFAULT_MESSAGE
  showToast({ type: 'error', message })
}
